'use strict';

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Button from '@material-ui/core/Button';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import EtablishmentRecap from 'Components/Front/EtablishmentRecap';
import SearchcityField from 'Components/Front/SearchcityField';
import bemit from 'Functions/bemit';
import LeftArrowIcon from 'Icons/LeftArrowIcon';
import Loader from 'Pure/Loader';
import { action } from 'Shared/Routes';
const {
  app
} = window;
const default_cities = [{
  label: 'Paris',
  value: 'Paris#75056'
}, {
  label: 'Lille',
  value: 'Lille#59350'
}, {
  label: 'Lyon',
  value: 'Lyon#69123'
}, {
  label: 'Strasbourg',
  value: 'Strasbourg#67482'
}, {
  label: 'Saint-Étienne',
  value: 'Saint-Étienne#42218'
}, {
  label: 'Bordeaux',
  value: 'Bordeaux#33063'
}];
export default function MapDetailsBlock(props) {
  const [searched, setSearched] = useState('');
  const [results, setResults] = useState(undefined);
  const [fetching, setFetching] = useState(false);
  useEffect(() => {
    if (results === undefined) return; // on mount or reset

    app.emit({
      event: 'UpdateSearchResultsMap',
      source: 'MapDetailsBlock',
      data: {
        etablishments: results
      }
    });
  }, [results]);
  const loader = fetching === true ? /*#__PURE__*/React.createElement(Loader, {
    className: "c-loader",
    bemit: ['blue', 'bg-white']
  }) : undefined;
  const cities = default_cities.map(function (opt) {
    const output = /*#__PURE__*/React.createElement("li", {
      className: "c-map-details-block__city",
      key: opt.value
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: e => selectCity(e, opt),
      className: "c-map-details-block__city-btn"
    }, opt.label));
    return output;
  });
  const output = /*#__PURE__*/React.createElement("div", {
    className: "c-map-details-block"
  }, results !== undefined ? /*#__PURE__*/React.createElement(Button, {
    type: "button",
    onClick: resetSearch,
    className: bemit('c-arrow-btn', ['primary']) + ' u-margin-bottom-10'
  }, /*#__PURE__*/React.createElement(LeftArrowIcon, {
    className: "c-arrow-btn__arrow"
  }), /*#__PURE__*/React.createElement("span", {
    className: "c-arrow-btn__text"
  }, "Retourner \xE0 la carte")) : undefined, /*#__PURE__*/React.createElement("h3", {
    className: "c-map-details-block__title",
    id: "map-details-block-title"
  }, "Trouvez votre espace myWO"), /*#__PURE__*/React.createElement("div", {
    className: "c-map-details-block__search"
  }, /*#__PURE__*/React.createElement(SearchcityField, {
    name: "research",
    onChange: handleSearchChange,
    className: "is-from-map-details-block",
    placeholder: "Paris",
    "aria-labelledby": "map-details-block-title"
  }), /*#__PURE__*/React.createElement(Button, {
    onClick: e => search(e),
    variant: "contained",
    color: "primary",
    className: bemit('c-flat-btn', ['blue', 'v2', 'map-details-btn'])
  }, "Rechercher")), /*#__PURE__*/React.createElement("h3", {
    className: "c-map-details-block__title u-margin-top-40"
  }, "Villes en France"), /*#__PURE__*/React.createElement("ul", {
    className: "c-map-details-block__cities"
  }, cities), results !== undefined && results.length === 0 ? /*#__PURE__*/React.createElement("div", {
    className: "u-full-width u-margin-top-20"
  }, getFormStatus({
    statement: 'Aucun établissement trouvé.'
  })) : undefined, props.etablishment ? /*#__PURE__*/React.createElement(EtablishmentRecap, {
    data: props.etablishment,
    "auto-scroll": true
  }) : undefined, loader);
  return output;
  function handleSearchChange({
    ...params
  }) {
    const {
      e,
      value: city,
      name
    } = params;
    props.onChange();
    setSearched(city.value);
    if (city) search(params.e, city.value);
  }
  function selectCity(e, opt) {
    search(undefined, opt.value);
  }
  async function search(e, custom) {
    props.onChange();
    setFetching(true);
    try {
      var {
        data: response
      } = await axios.post(action('searchAllEtablishments'), {
        searched: typeof custom === 'undefined' ? searched : custom,
        order: 'asc',
        order_by: 'name'
      });
      setFetching(false);
      setResults(response.data || []);
    } catch (e) {
      setFetching(false);
      return console.error(e?.error || e);
    }
  }
  function resetSearch() {
    app.emit({
      event: 'ResetSearchResultsMap',
      source: 'MapDetailsBlock'
    });
    setResults(undefined);
  }
}
